import { render } from "./MobileFloating.vue?vue&type=template&id=2cbaf35f&scoped=true"
import script from "./MobileFloating.vue?vue&type=script&lang=js"
export * from "./MobileFloating.vue?vue&type=script&lang=js"

import "./MobileFloating.vue?vue&type=style&index=0&id=2cbaf35f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbaf35f"]])

export default __exports__